import { buildFacetManager, buildFacet, Facet, FacetManager } from '@coveo/headless';
import headlessEngine from './headlessEngine';

export const facetManager: FacetManager = buildFacetManager(headlessEngine);

export const studyTypeFacet: Facet = buildFacet(headlessEngine, {
  options: { field: 'trialstudytype' },
});

export const maxAgeFacet: Facet = buildFacet(headlessEngine, { options: { field: 'trialmaxage' } });

export const phaseFacet: Facet = buildFacet(headlessEngine, { options: { field: 'trialphase' } });

export const genderFacet: Facet = buildFacet(headlessEngine, {
  options: { field: 'trial_gender_list' },
});

export const minAgeFacet: Facet = buildFacet(headlessEngine, { options: { field: 'trialminage' } });

export const enrollingFacet: Facet = buildFacet(headlessEngine, {
  options: { field: 'trialenrollingstatus' },
});

export const relatedTermsFacet: Facet = buildFacet(headlessEngine, {
  options: { field: 'trialconditions' },
});

export const trialenrollmenttypeFacet: Facet = buildFacet(headlessEngine, {
  options: { field: 'trialenrollmenttype' },
});

export const completiondateFacet: Facet = buildFacet(headlessEngine, {
  options: { field: 'trialcompletiondate' },
});
